import { useMemo } from 'react'

const useBoothStatusButton = (booth_status: string) => {
  const buttons = useMemo(() => {
    const buttonVisibility = {
      modify: false,
      cancel: false,
      refund: false,
      payment: false,
      addInfoModify: true,
    }

    switch (booth_status) {
      case 'B0100002':
        // 신청서 수정 및 취소 가능
        buttonVisibility.modify = true
        buttonVisibility.cancel = true
        break
      case 'B0100003':
        // 신청서 수정 불가능, 취소 가능, 결제 가능
        buttonVisibility.cancel = true
        buttonVisibility.payment = true
        break
      case 'B0100004':
        // 환불 가능
        buttonVisibility.refund = true
        break
      case 'B0100005':
      case 'B0100006':
      case 'B0100008':
      case 'B0100009':
        // 모든게 다 불가능, 추가 정보 수정 비활성화
        buttonVisibility.addInfoModify = false
        break
      default:
        break
    }

    return buttonVisibility
  }, [booth_status])

  return buttons
}

export default useBoothStatusButton
